module.exports = __webpack_public_path__ + "static/media/swiftworld.19f86c0b.png";